export default __webpack_public_path__ + "media/videos/premier_video.mp4";